import { render, staticRenderFns } from "./tarifa-config-global.vue?vue&type=template&id=755e8e4b&scoped=true"
import script from "./tarifa-config-global.vue?vue&type=script&lang=js"
export * from "./tarifa-config-global.vue?vue&type=script&lang=js"
import style0 from "./tarifa-config-global.vue?vue&type=style&index=0&id=755e8e4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755e8e4b",
  null
  
)

export default component.exports